export default __webpack_public_path__ + "static/media/card.563ae385.svg";